import { render, staticRenderFns } from "./TSZ_Usuarios_Internos.vue?vue&type=template&id=48363842&scoped=true&"
import script from "./TSZ_Usuarios_Internos.vue?vue&type=script&lang=js&"
export * from "./TSZ_Usuarios_Internos.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Usuarios_Internos.vue?vue&type=style&index=0&id=48363842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48363842",
  null
  
)

export default component.exports